import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as LoginArrow } from "../../assets/loginArrow.svg";
import { ReactComponent as ManageCourseImg } from "../../assets/manageCourse.svg";
import { ReactComponent as ManageUsersImg } from "../../assets/manageUsers.svg";
import { ReactComponent as ManageCategoryImg } from "../../assets/manageCategory.svg";
import {
  isAuthenticated,
  signout,
  checkForAdmin,
  checkForSuperAdmin,
} from "../../auth/helper/auth";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const checkForActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar-menu-parent">
      <div className="navbar-menu">
        <div
          className="navbar-menu-logo"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <Logo />
          <h1>iNeuron Courses</h1>
        </div>
        <div className="navbar-menu-links">
        <div className="nav-menu-item-manage">
        <Link
                  to="practise"
                  className={`nav-menu-item ${
                    checkForActive("practise") && "active"
                  }`}>Practise</Link>
          </div>
          {isAuthenticated() && checkForAdmin(isAuthenticated()?.user) && (
            <div className="nav-menu-item-manage">
              <span>Manage</span>
              <div className="nav-menu-item-hover-div">
                <Link
                  to="/course/manage"
                  className={`nav-menu-item ${
                    checkForActive("/course/manage") && "active"
                  }`}
                >
                  <ManageCourseImg width={20} /> <span>Manage Courses</span>
                </Link>
                <Link
                  target={"_blank"}
                  to="/category/manage"
                  className={`nav-menu-item ${
                    checkForActive("/category/manage") && "active"
                  }`}
                >
                  <ManageCategoryImg width={20} />{" "}
                  <span>Manage Categories</span>
                </Link>

                {checkForSuperAdmin(isAuthenticated()?.user) && (
                  <Link
                    to="/users/manage"
                    className={`nav-menu-item ${
                      checkForActive("/users/manage") && "active"
                    }`}
                  >
                    <ManageUsersImg width={20} /> <span>Manage Users</span>
                  </Link>
                )}
              </div>
            </div>
          )}
          {!isAuthenticated() ? (
            location.pathname !== "/login" && (
              <button
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/login");
                }}
              >
                Log in <LoginArrow className="loginArrow" />
              </button>
            )
          ) : (
            <button
              onClick={(e) => {
                e.preventDefault();
                signout(() => {
                  navigate("/login");
                });
              }}
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
